import type { FaireProductEntity } from "../../entity_types/product";

export const p_cjq3uw2pnb: FaireProductEntity = {
  token: "p_cjq3uw2pnb",
  type: "product",
  name: "MAHJONG GIRLIE GRAPHIC TEE",
  brandToken: "b_2wnzlaczud",
  brandName: "JADE BY JANE",
  imageUrl:
    "https://cdn.faire.com/fastly/891f9bea291ef40ed9c8249bad80d0cf941cf812a4005a1afa0a37a43b519e8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81bc7a748edc6ee09097914f25c4c02fcf8bcdd55e447774aedb8651bbdcf780.jpeg",
    "https://cdn.faire.com/fastly/ec5525e2139d7048fb55f895c23ed3e9b36d444ba3ef4a5206bc5cab9816401e.jpeg",
    "https://cdn.faire.com/fastly/a39eecbe317afa184fc7f80210305fbc319860b1a73f53817107436a37103a5f.jpeg",
    "https://cdn.faire.com/fastly/fd7eb17721d9aa00b0daae17d7ee5a13dfd84bcc31f5da76f1c50b7101b844cf.jpeg",
    "https://cdn.faire.com/fastly/06814af16952eaf6f4b33a9e0a2e8aeca51d305211ec749a3f3cfd02c8518dbb.jpeg",
    "https://cdn.faire.com/fastly/a7e6bf48a75ac9416105fd302f2f4cb447b0f6372fc2913e3d8513725f24c899.jpeg",
    "https://cdn.faire.com/fastly/8d420f0b905db6c9cc11626246497168f0ddb3cfb7aa23a7486de1b244ede33c.jpeg",
    "https://cdn.faire.com/fastly/0c1425f476601c4c9173cbc7863e34144ab6733f28e39b4e755f8f2b49430da5.jpeg",
    "https://cdn.faire.com/fastly/b7c73954e78a5dab2631410b791b820e8b59816f43ad1ade8980a63c4997d624.jpeg",
    "https://cdn.faire.com/fastly/29338a8da9e48f47907ae9cac8637185bd5666a077b2837aeb123acd48d916c6.jpeg",
    "https://cdn.faire.com/fastly/344e26fd8b022f703b10cbaed4a1f8bf30c5965cba2f9b0f600d66e8e23bb84f.jpeg",
    "https://cdn.faire.com/fastly/dafba0836790ac31cf73843f5f3507cef75f6ac3ef5c74a31ba1419d19586d10.jpeg",
    "https://cdn.faire.com/fastly/7f5f7358ceb266a95eaf40637803d2bd111248b64525fbc0cedf6729e48152ff.jpeg",
    "https://cdn.faire.com/fastly/61d669cb3d2c8392a612232938486386dac7e821f29943d8dd7071b737d2ab1d.jpeg",
    "https://cdn.faire.com/fastly/ad3b9474b5460b7c2eb490f8dab9992bbae32321e7189ffb75a9da9dbbbdf685.jpeg",
    "https://cdn.faire.com/fastly/6a931c9db44d9e6919830360bcb0effc55ca3a2f46f8f6b7bf08cf62087ace54.png",
  ],
  priceDollars: 15.95,
  description:
    "MAHJONG GIRLIE GRAPHIC TEE\n\n- Casual silhouette\n- Relaxed fit\n- Cotton fabrication\n- Front chest graphic and text printed\n- Classic ribbed crew neckline\n\nPACK SIZE\nS-M-L-XL (1-1-1-1)\n2X (1)",
  tags: [],
  msrpDollars: 31.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:40.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
